import React from "react";
import { STRINGS } from "constants/strings.constant";
import "./ar_loading_view.ui.scss";

const ArLoadingView = (): React.ReactElement => (
  <div className="ar_loading_view" role="status">
    <span className="ar_loading_view_spinner" aria-hidden="true" />
    <span className="ar_loading_view_label">{STRINGS.ar.loading}</span>
  </div>
);

export default ArLoadingView;
